import React from 'react';

const SIngleContactInfo = ({image,title,text,btn_text}) => {
   return (
      <>
         <div className="col-xl-5 col-lg-6 col-md-6 offset-xl-1">
            <div className="contact__help-item white-bg text-center mb-30 wow fadeInLeft" data-wow-delay=".3s">
               <div className="contact__icon mb-35">
                  <img src={`assets/img/icon/contact/${image}.png`} alt="" />
               </div>
               <div className="contact__text">
                  <h3>{title}</h3>
                  <p>{text}</p>
                  <a href="tel:+16145340560" className="z-btn z-btn-border">{btn_text}</a>
               </div>
            </div>
         </div>
      </>
   );
};

export default SIngleContactInfo;